export default __webpack_public_path__ + "static/media/fc-brand.cffc2af1.svg";